let socket;
let heartbeatInterval;
const heartbeatFrequency = 1750000;
const listeners = new Set();

// Queue of messages to send once the socket is open
let pendingMessages = [];

export const connectWebSocket = (url) => {
  if (socket) {
    stopHeartbeat();
    socket.close();
  }
  const ws = new WebSocket(url);
  socket = ws;
  ws.onopen = () => {
    console.warn("WebSocket connection established");
    startHeartbeat();
    pendingMessages.forEach((msg) => ws.send(msg));
    pendingMessages = [];
  };
  ws.onclose = () => {
    console.warn("WebSocket connection closed");
    stopHeartbeat();
  };
  ws.onerror = (error) => {
    console.error("WebSocket error: ", error);
  };
  ws.onmessage = (event) => {
    const message = JSON.parse(event.data);
    listeners.forEach((cb) => cb(message));
  };
};

/**
 * Send a message through the socket, queuing it if not yet connected.
 */
const safeSend = (payload) => {
  const msg = JSON.stringify(payload);
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(msg);
  } else {
    pendingMessages.push(msg);
  }
};

const startHeartbeat = () => {
  heartbeatInterval = setInterval(() => {
    if (socket && socket.readyState === WebSocket.OPEN)
      socket.send(JSON.stringify({ action: "heartbeat" }));
  }, heartbeatFrequency);
};

const stopHeartbeat = () => {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
};

export const subscribeToNotifications = (userId) => {
  safeSend({ action: "subscribe", userId });
};

/**
 * Register a message listener. Returns an unsubscribe function.
 * Supports multiple concurrent listeners (unlike the previous single-handler approach).
 * @param {Function} callback - Called with parsed message object
 * @returns {Function} Unsubscribe function
 */
export const onMessage = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

export const closeWebSocket = () => {
  if (socket) {
    stopHeartbeat();
    socket.close();
  }
  listeners.clear();
  pendingMessages = [];
};
